<template>


  <div class="page">
    <loading v-if="showLoading"></loading>
    <!-- Begin Header -->
    <header class="header">
      <nav class="navbar fixed-top">
        <!-- Begin Topbar -->
        <div class="navbar-holder d-flex align-items-center align-middle justify-content-between">
          <!-- Begin Logo -->
          <div class="navbar-header">
            <a v-bind:href="$siteUrl" class="navbar-brand">
              <div class="brand-image brand-big">
                <img src="../assets/img/logo-big.png" alt="logo" class="logo-big">
              </div>
              <div class="brand-image brand-small">
                <img src="../assets/img/logo.png" alt="logo" class="logo-small">
              </div>
            </a>
            <!-- Toggle Button -->
            <a id="toggle-btn" href="#" class="menu-btn active">
              <span></span>
              <span></span>
              <span></span>
            </a>
            <!-- End Toggle -->
          </div>
          <!-- End Logo -->

        </div>
        <!-- End Topbar -->
      </nav>
    </header>
    <!-- End Header -->
    <!-- Begin Page Content -->
    <div class="page-content d-flex align-items-stretch">
      <div class="default-sidebar">
        <!-- Begin Side Navbar -->
        <nav class="side-navbar box-scroll sidebar-scroll">
          <!-- Begin Main Navigation -->
          <ul class="list-unstyled">

            <li><router-link :to="$base_url+'/'"><i class="la la-mouse-pointer"></i><span>داشبورد</span></router-link></li>

            <li :class="active_item=='products' ? 'active' : ''"><a href="#dropdown" aria-expanded="false" data-toggle="collapse"><i class="la la-apple"></i><span>محصولات</span></a>
              <ul id="dropdown" :class="active_item=='products' ? 'collapse list-unstyled show pt-0' : 'collapse list-unstyled pt-0'">
                <li>
                  <router-link :to="$base_url+'/products'">مدیریت محصولات</router-link>
                </li>
                <li>
                  <router-link :to="$base_url+'/products/add'">افزودن محصول جدید</router-link>
                </li>
                <li>
                  <router-link :to="$base_url+'/products/all'">قیمت گذاری محصولات</router-link>
                </li>

              </ul>
            </li>

            <li :class="active_item=='orders' ? 'active' : ''"><a href="#dropdown2" aria-expanded="false" data-toggle="collapse"><i class="la la-shopping-cart"></i><span>سفارشات</span></a>
              <ul id="dropdown2" :class="active_item=='orders' ? 'collapse list-unstyled show pt-0' : 'collapse list-unstyled pt-0'">
                <li>
                  <router-link :to="$base_url+'/orders'">مدیریت سفارشات</router-link>
                </li>

              </ul>
            </li>

            <li :class="active_item=='report' ? 'active' : ''"><a href="#dropdown3" aria-expanded="false" data-toggle="collapse"><i class="la la-bar-chart"></i><span>گزارشات</span></a>
              <ul id="dropdown3" :class="active_item=='report' ? 'collapse list-unstyled show pt-0' : 'collapse list-unstyled pt-0'">
                <li>
                  <router-link :to="$base_url+'/orders/sale_statistics'">آمار فروش</router-link>
                </li>
                <li>
                  <router-link :to="$base_url+'/orders/payments'">مدیریت پرداخت ها</router-link>
                </li>

              </ul>
            </li>

            <li :class="active_item=='package' ? 'active' : ''"><a href="#dropdown4" aria-expanded="false" data-toggle="collapse"><i class="la la-cube"></i><span>انبار</span></a>
              <ul id="dropdown4" :class="active_item=='package' ? 'collapse list-unstyled show pt-0' : 'collapse list-unstyled pt-0'">
                <li>
                  <router-link :to="$base_url+'/package/inventory'">موجودی های انبار</router-link>
                </li>
                <li>
                  <router-link :to="$base_url+'/package'">مدیریت محموله ها</router-link>
                </li>
                <li>
                  <router-link :to="$base_url+'/package/add'">افزودن محموله جدید</router-link>
                </li>

              </ul>
            </li>


            <li :class="active_item=='messages' ? 'active' : ''"><a href="#dropdown5" aria-expanded="false" data-toggle="collapse"><i class="la la-envelope"></i><span>پیام ها</span></a>
              <ul id="dropdown5" :class="active_item=='messages' ? 'collapse list-unstyled show pt-0' : 'collapse list-unstyled pt-0'">
                <li>
                  <router-link :to="$base_url+'/messages'">مدیریت پیام ها</router-link>
                </li>
              </ul>
            </li>

            <li :class="active_item=='setting' ? 'active' : ''"><a href="#dropdown6" aria-expanded="false" data-toggle="collapse"><i class="la la-cog"></i><span>تنظیمات</span></a>
              <ul id="dropdown6" :class="active_item=='setting' ? 'collapse list-unstyled show pt-0' : 'collapse list-unstyled pt-0'">
                <li>
                  <router-link :to="$base_url+'/setting/profile'">ویرایش پروفایل</router-link>
                </li>
              </ul>
            </li>


            <li><a href="javascript:void(0);" v-on:click="logout_dialog()"><i class="la la-power-off"></i><span>خروج</span></a></li>


          </ul>

          <ul class="list-unstyled">
            <li><a v-bind:href="$siteUrl"><i class="la la-angle-left"></i><span>برگشت به فروشگاه</span></a></li>
          </ul>
          <!-- End Main Navigation -->
        </nav>
        <!-- End Side Navbar -->
      </div>
      <!-- End Left Sidebar -->
      <div class="content-inner">
        <div class="container-fluid">
          <!-- Begin Page Header-->
          <div class="row">
            <div class="page-header">
              <div class="d-flex align-items-center">
                <h2 class="page-header-title">{{ brand_name }}</h2>
              </div>
            </div>
          </div>
          <!-- End Page Header -->
          <!-- Begin Row -->
          <div class="row flex-row">

                <div class="col-xl-12 col-12">
                  <router-view @setSideBarItem="setSideBarItem" @updateInfo="updateInfo"></router-view>
                </div>


                <div class="message_div" v-if="showMessageDialog">
                  <div class="message_box">
                    <p id="msg">آیا میخواهید از پنل مدیریت خارج شوید</p>

                    <a class="alert alert-success" v-on:click="logoutUser()">بله</a>
                    <a class="alert alert-danger" v-on:click="showMessageDialog=!showMessageDialog">خیر</a>
                  </div>
                </div>

                <server-error-message v-if="server_error"></server-error-message>


          </div>
          <!-- End Row -->
        </div>
        <!-- End Container -->
        <!-- Begin Page Footer-->
        <footer class="main-footer fixed-footer">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex align-items-center justify-content-xl-start justify-content-lg-start justify-content-md-start justify-content-center">
              <p class="text-gradient-02">تمامی حقوق برای فروشگاه ایران کالا محفوظ است.</p>
            </div>
          </div>
        </footer>
        <!-- End Page Footer -->
        <a href="#" class="go-top"><i class="la la-arrow-up"></i></a>

      </div>
      <!-- End Content -->
    </div>
    <!-- End Page Content -->
  </div>

</template>

<script>
import myMinix from "../myMixin";
import ServerErrorMessage from "./ServerErrorMessage";
export default {
  mixins: [myMinix],
  components: { ServerErrorMessage },
  data() {
    return {
      active_item: "",
      showMessageDialog: false,
      showLoading: false,
      server_error: false,
      brand_name: ""
    };
  },
  mounted() {
    const getUserData = this.$route.params.getUserData;
    if (getUserData == "yes") {
      this.showLoading = true;
      this.getSellerInfo();
    } else {
      if (localStorage.getItem("brand_name") != undefined) {
        this.brand_name = localStorage.getItem("brand_name");
      }
    }

    $('#toggle-btn').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');

      $('.side-navbar').toggleClass('shrinked');
      $('.content-inner').toggleClass('active');

      if ($(window).outerWidth() > 1183) {
        if ($('#toggle-btn').hasClass('active')) {
          $('.navbar-header .brand-small').hide();
          $('.navbar-header .brand-big').show();
        } else {
          $('.navbar-header .brand-small').show();
          $('.navbar-header .brand-big').hide();
        }
      }

      if ($(window).outerWidth() < 1183) {
        $('.navbar-header .brand-small').show();
      }
    });
  },
  methods: {

    setSideBarItem: function(item) {
      this.active_item = item;
    },

    logout_dialog: function() {
      this.showMessageDialog = true;
    },
    logoutUser: function() {
      const token = localStorage.getItem("token");
      this.showMessageDialog = false;
      this.showLoading = true;
      const url = this.$siteUrl + "/api/seller/logout";
      this.axios
        .post(url, {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token
          }
        })
        .then(response => {
          this.showLoading = false;
          alert(response.data);
          if (response.data == "ok") {
            this.logout();
          } else {
            this.show_server_error();
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.logout();
          } else {
            this.showLoading = false;
            this.show_server_error();
          }
        });
    },
    updateInfo:function(){
      this.brand_name = localStorage.getItem("brand_name");
    }
  }
};
</script>
